import { render, staticRenderFns } from "./KompasApp.vue?vue&type=template&id=4c403e77&scoped=true&"
import script from "./KompasApp.vue?vue&type=script&lang=js&"
export * from "./KompasApp.vue?vue&type=script&lang=js&"
import style0 from "./KompasApp.vue?vue&type=style&index=0&id=4c403e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c403e77",
  null
  
)

export default component.exports